module.exports = __webpack_public_path__ + "img/4.a1aeb962.jpg";